import { useEffect } from "react";
import ListQuestions from "../components/Questions/ListQuestions";

import styles from "./css/commonQuestions.module.css"

export default function CommonQuestions({ setHeader }) {

    useEffect(() => {
        setHeader(true);
    }, []);

    return (
        <div className={styles.tableContainer}>
            <ListQuestions />
        </div>

    );
}